import { ChevronsUpDownIcon } from 'lucide-react'
import { type ComponentPropsWithoutRef, forwardRef, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface ComboboxTriggerProps extends Omit<ComponentPropsWithoutRef<'button'>, 'disabled'> {
  isOpen: boolean
  isDisabled: boolean
  children: ReactNode
}

/**
 * Base trigger button for combobox/selector components.
 * Provides consistent styling and accessibility for dropdown triggers.
 */
export const ComboboxTrigger = forwardRef<HTMLButtonElement, ComboboxTriggerProps>(
  ({ isOpen, isDisabled, className, children, ...rest }, ref): ReactNode => (
    <Button
      ref={ref}
      type="button"
      variant="outline"
      role="combobox"
      aria-expanded={isOpen}
      disabled={isDisabled}
      className={cn('w-full justify-between font-normal', className)}
      {...rest}
    >
      {children}
      <ChevronsUpDownIcon className="ml-2 size-4 shrink-0 opacity-50" />
    </Button>
  )
)

ComboboxTrigger.displayName = 'ComboboxTrigger'
